export default __webpack_public_path__ + "wp-content/uploads/react/user-dashboard/media/logoHOMECARE360.6247b70c.svg";